import { createApp } from 'vue'
// element plus
import './common/elementPlusCustom.scss'
import ElementPlus, { ElIcon } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// element plus end
import App from './App.vue'
import router from './router' // 这里，注意，elementplus要在router之前引入，要不样式会有问题
import store from './store'
import './utils/consts'
import './utils/utils'

createApp(App).use(ElementPlus, { locale: zhCn }).use(ElIcon).use(router).use(store).mount('#app')
